import { createStore, applyMiddleware, compose } from 'redux'
import reduxThunk from 'redux-thunk'
import roosterReducer from '../reducers/index'
import topsReducer from '../reducers/index.tops'

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const reducers = process.env.REACT_APP_IS_TOPS ?
  topsReducer :
  roosterReducer

export default initialState => (
  createStore(
    reducers,
    initialState,
    composeEnhancer(
      applyMiddleware(reduxThunk),
    ),
  )
)



// WEBPACK FOOTER //
// ./src/state/store/configure.js